module.exports = __webpack_public_path__ + "img/logo_login_dark.41b7a182.png";